export enum FlagEnum {
  Calculations = 'calculations',
  CalculationsCreate = 'calculations.create',
  CalculationsList = 'calculations.list',
  CalculationsSection84_1 = 'calculations.section_84_1',
  CalculationsRollover = 'calculations.rollover',
  CalculationsRRQ = 'calculations.rrq',
  CalculationsSalaryDividend = 'calculations.salary_dividend',
  CalculationsRrsp = 'calculations.rrsp',

  ClientQuestionnaires = 'client.questionnaires',
  ClientQuestionnairesCreate = 'client.questionnaires.create',
  ClientQuestionnairesList = 'client.questionnaires.list',
  ClientQuestionnairesQuebec2022TaxForm = 'client.questionnaires.quebec_2022_tax_form',
  ClientQuestionnairesQuebec2023TaxForm = 'client.questionnaires.quebec_2023_tax_form',
  SalaryDividendTaxForm = 'client.questionnaires.salary_dividend_tax_form',

  PortalFileUploads = 'client-portal.file.uploads'
}